import actionCreatorFactory from 'typescript-fsa';
import { Dispatch, Action } from 'redux';
import { fetchAuthSession, getCurrentUser } from 'aws-amplify/auth';
import { getAPI } from '../utils/APIUtils';

import { informationActions } from './informationAction';
import { approvalAction } from './approvalAction';
import { editingAction } from './editingAction';
import { whatsnewAction } from './whatsnewAction';
import { repealActions } from './repealAction';
import { searchActions } from './searchAction';
import { settingAction } from './settingAction';
import { Acttemplate } from '../states/appState';

export interface Profile {
  id: string;
  name: string;
  email: string;
  accountid: string;
  govName: string;
  govNameSuffix: string;
  userGroupId: string;
  startDate: string;
  role: string;
  idid: string;
}

const actionCreator = actionCreatorFactory();

export const appActions = {
  getProfile: actionCreator<string>('ACTIONS_GET_PROFILE'),
  initProfile: actionCreator<Profile>('ACTION_INIT_PROFILE'),
  initEditstateList: actionCreator<any>('ACTIONS_INIT_EDITSTATELIST'),
  initEditTypeList: actionCreator<any>('ACTIONS_INIT_EDITTYPELIST'),
  getActtemplate: actionCreator<Acttemplate[]>('ACTIONS_GET_ACTTEMPLATE'),
  getActtemplateAsync: (accountid: string) => {
    return async (dispatch: Dispatch<Action>) => {
      try {
        const url1 = `/acttemplate?accountid=${accountid}`;
        const json = await getAPI(url1);

        dispatch(appActions.getActtemplate(json));

      } catch (err) {
        console.log(err);
      }
      dispatch(appActions.setLoading(false));
    };
  },
  initApplicationsAsync: (pathname: string) => {
    return async (dispatch: Dispatch<Action>) => {
      try {
        const userS = await fetchAuthSession();
        const user = await getCurrentUser();

        // ユーザ情報取得API呼び出し
        const url1 = `/user/${user.username}`;
        const res1 = await getAPI(url1);

        const result: Profile = {
          id: user.username,
          name: res1.name,
          email: res1.eMail,
          accountid: res1.accountId,
          govName: res1.govName,
          govNameSuffix: res1.govNameSuffix,
          userGroupId: res1.userGroupId,
          startDate: res1.startDate,
          role: res1.role,
          idid: userS.identityId || user.username, // LGWAN環境ではIDIDを利用していないためユーザ名で代用
        };
        dispatch(appActions.initProfile(result));

        {
          const url2 = `/settings/${result.accountid}/editstate`;
          const json2 = await getAPI(url2);
          dispatch(appActions.initEditstateList(json2));
        };

        {
          const url2 = `/settings/${result.accountid}/edittype`;
          const json2 = await getAPI(url2);
          dispatch(appActions.initEditTypeList(json2));
        };

        {
          const url2 = `/settings/${result.accountid}/catalog`;
          const json2 = await getAPI(url2);
          dispatch(searchActions.initCatalogs(json2));
        };

        {
          const url2 = `/settings/${result.accountid}/field`;
          const json2 = await getAPI(url2);
          dispatch(searchActions.initFields(json2));
        };

        await informationActions.getInformationsAsync(result.accountid, result.id, true)(dispatch);
        await editingAction.getMyEditingAsync(result.accountid, result.id, true)(dispatch);
        await whatsnewAction.getWhatsnewAsync(result.accountid, result.id, true)(dispatch);

        switch (pathname) {
          case '/approval':
            await approvalAction.getApprovalActsAsync(result.accountid, result.id)(dispatch);
            break;
          case '/editing':
            await editingAction.getEditingAsync(result.accountid, result.id)(dispatch);
            break;
          case '/repeal':
            await repealActions.searchRepealAsync({ mode: 'act', words: '', rowsPerPage: 100, page: 0, userGroupId: res1.userGroupId, }, res1.accountId)(dispatch);
            break;
          case '/settings':
            await settingAction.getUserAsync(result.accountid, result.idid, res1.role, 0, 20)(dispatch);
            break;
          default:
            break;
        }
      } catch (err) {
        console.log(err);
      }
      dispatch(appActions.setLoading(false));
    };
  },
  setOpenNewActDialog: actionCreator<boolean>('ACTION_SET_OPEN_NEW_ACT_DIALOG'),
  setOpenPubContentsDialog: actionCreator<boolean>('ACTION_SET_OPEN_PUB_CONTENTS_DIALOG'),
  getPubContentsItem: actionCreator<boolean>('ACTION_GET_OPEN_PUB_CONTENTS_ITEM_DIALOG'),
  getPubContentsItemAsync: (accountid: string) => {
    return async (dispatch: Dispatch<Action>) => {
      try {
        const url1 = `/pubcontents?accountid=${accountid}`;
        const json1 = await getAPI(url1);

        dispatch(appActions.getPubContentsItem(json1));

      } catch (err) {
        console.log(err);
      }
      dispatch(appActions.setLoading(false));
    };
  },
  setLoading: actionCreator<boolean>('ACTIONS_SET_LOADING'),
};
